<template>
  <div class="kp-modular-row clearfix">
    <label class="kp-label-aling">{{$t('edit.sidebar.alignment')}}</label>
    <select class="klickart-select">
      <option value="none" :selected="value() === 'none'">{{$t('general.labels.center')}}</option>
      <option value="left" :selected="value() === 'left'">{{$t('general.labels.left')}}</option>
      <option value="right" :selected="value() === 'right'">{{$t('general.labels.right')}}</option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const defaultFloatValue = 'none';

export default {
  mounted() {
    const select = this.$el.querySelector('select');

    select.addEventListener('change', (event) => {
      this.onChange(event.target.value);
    });
  },
  updated() {
    const margin = this.boxConfig.trigger_button.style.margin;

    if (!margin) {
      this.boxUpdateConfigStyle({
        item: 'trigger_button',
        rule: 'margin',
        value: '0 auto',
      });
    }
  },
  methods: {
    value() {
      let floatValue = this.boxConfig.trigger_button.style.float;

      if (!floatValue) {
        floatValue = defaultFloatValue;
      }

      return floatValue;
    },
    updateConfig(float) {
      this.boxUpdateConfigStyle({
        item: 'trigger_button',
        rule: 'float',
        value: `${float}`,
      });
    },
    onChange(value) {
      this.updateConfig(value);
    },
    ...mapActions([
      'boxUpdateConfigStyle',
    ]),
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Align.vue?6b3a4422
 **/